import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as TourActions from './tour.actions';
import { TourLongDto } from '@api/rest';

export const toursFeatureKey = 'tours';

export interface State extends EntityState<TourLongDto> {
  selected: string;
}

export const adapter: EntityAdapter<TourLongDto> = createEntityAdapter<TourLongDto>({
  selectId: tour => tour._id
});

export const initialState: State = adapter.getInitialState({
  selected: undefined
});


export const reducer = createReducer(
  initialState,
  on(TourActions.loadToursSuccess, (state, action) =>
    adapter.setAll(action.tours, state)
  ),
  on(TourActions.getTourSuccess, (state, action) =>
    adapter.upsertOne(action.tour, state)
  ),
  on(TourActions.setSelectedTour, (state, action) =>
    ({ ...state, selected: action.id })
  )
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
